<template>
  <section id="impactHF" :class="{'pretty-bottom': !(!toShowOverviewTab && state?.sightings?.length > 0), 'bgLight pretty-top': state?.availabelStatusSection?.indexOf('hasHFSection')%2 === 0}" 
  class="section"  v-if="state?.tsn && state?.hasHFSection">
    <div class="container has-text-centered condensed">
      <div class="columns">
        <div class="column">
          <h2>{{ $t("profile.ABStatus.impactHF.sectionHeader") }} </h2>
          <div class="profile richtext bold" v-html="sppContent?.WebHFEffect"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <hr/>
      <div class="column" v-if="state?.isForestModel == dataModel.full">
        <sector-effect-section :isNorth="true" :isSpecies="true"  />
      </div>
      <hr v-if="state?.isPrairieModel === dataModel.full && state?.isForestModel == dataModel.full"/>
      <div class="column" v-if="state?.isPrairieModel === dataModel.full">
        <sector-effect-section :isNorth="false" :isSpecies="true" :hideForestry="true"/>
      </div>

      <div v-if="state?.isPrairieModel === dataModel.full || state?.isForestModel === dataModel.full">
        <linear-hf-sub-section :isNorth="true" :isSpecies="true"/>
      </div>
      <div class="button-container">
        <a :href="$t('profile.ABStatus.impactHF.downloadLink')" target="_blank" class="button is-primary">{{ $t("common.downloadButtonText")}}</a>
      </div>
    </div>
  </section>

</template>

<script>
import { DATA_MODEL as dataModel } from '@/config/profile-config';
import { useApp } from '@/composables/state/profileState';

import SectorEffectSection from './SectorEffectSubSection.vue';
import LinearHfSubSection from './LinearHfSubSection.vue';
export default {
  components: { SectorEffectSection, LinearHfSubSection },
  name: 'impact-hf-section',
  setup () {
    const { state, sppContent, toShowOverviewTab } = useApp();
    return {
      state,
      sppContent,
      dataModel,
      toShowOverviewTab
    }
  }
}
</script>

<style>
.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 0;
}

.button-container a {
  font-size: .6rem !important;
  height: 2rem !important;
  min-height: 2rem !important;
  padding: 0.5rem 1rem !important;
  margin-top: 1rem !important;
}
</style>
